/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';

export const ComparatorsSigns = {
  eq: '=',
  in: '∈',
  ni: '∉',
  ne: '≠',
  gt: '>',
  lt: '<',
  bt: '[]',
  lk: '≈',
  any: '∈',
  all: '='
};

export type TComparatorOption = {
  sign: string;
  label: string;
  key: TComparator;
};

interface FiltersComparatorSelectSignature {
  Args: {
    comparators: TComparator[];
    selected?: TComparator;
    onChange?: (comparator: TComparatorOption) => void;
    name?: string;
  };
  Element: HTMLDivElement;
}

export default class FiltersComparatorSelectComponent extends Component<FiltersComparatorSelectSignature> {
  get comparatorOptions(): TComparatorOption[] {
    const { comparators } = this.args;
    return comparators.map((comparator) => {
      return {
        key: comparator,
        sign: ComparatorsSigns[comparator],
        label: `comparators.${comparator}`
      };
    });
  }

  get selectedComparatorOption() {
    return this.comparatorOptions.find((c) => c.key === this.args.selected);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Filters::ComparatorSelect': typeof FiltersComparatorSelectComponent;
    'filters/comparator-select': typeof FiltersComparatorSelectComponent;
  }
}
